import React from 'react';
import useFormInputs from 'shared/migration-components/form/util';
import {AddressProps, translatedAddressProps} from 'modules/addresses/types';
import Edition from 'shared/layout/edition';
import {useParams} from 'react-router-dom';
import useEditAddress, {
  EditAddressProps,
} from 'modules/addresses/hooks/use-edit-address';

const CreateAddress: React.FC = () => {
  const {id} = useParams();
  const {getInput, getAddressInput} = useFormInputs<EditAddressProps>();

  const handleSubmit = ({address, name}: EditAddressProps) => {
    return {
      name,
      ...address,
    };
  };

  const handleDefaultValues = (data: AddressProps): EditAddressProps => {
    const {name, ...address} = data;

    const {street, number, neighborhoodId, cityId, state, latitude, longitude} =
      address;

    return {
      name,
      address: {
        street,
        number,
        neighborhoodId,
        cityId,
        state,
        latitude,
        longitude,
      },
    };
  };

  return (
    <Edition<EditAddressProps>
      titleBar={{title: 'Editar endereço'}}
      onSubmit={() => useEditAddress(id!)}
      detailsUrl={`/addresses/${id}`}
      {...{handleDefaultValues, handleSubmit}}
      inputs={[
        getInput({
          name: 'name',
        }),
        getAddressInput({
          label: 'Endereço',
          name: 'address',
          confirmCoordinates: true,
        }),
      ]}
      translationKey={translatedAddressProps}
    />
  );
};

export default CreateAddress;
